import { css } from 'lit';

document.documentElement.style.setProperty('--refi-header-color', '#10253F');
document.documentElement.style.setProperty('--refi-checkout-card-padding-inline', '1rem');
document.documentElement.style.setProperty('--refi-checkout-card-padding-block', '0.75rem');

export const globalStyle = css``;
